var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainPathway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.543 21.0833H25.7886",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 35.75C23.8333 38.3167 20.1667 40.3333 20.1667 40.3333C20.1667 40.3333 16.5 38.3167 16.5 35.75C16.5 33.1833 19.0025 33 20.1667 33C21.3308 33 23.8333 33.1833 23.8333 35.75Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 4.58333V2.75",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.834 0.916687V4.58335",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 2.75H33",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1668 17.4167H39.0501C38.5355 17.4127 38.0335 17.5754 37.619 17.8805C37.2045 18.1855 36.9 18.6165 36.7508 19.1091C36.6016 19.6016 36.6158 20.1292 36.7914 20.6129C36.9669 21.0967 37.2943 21.5106 37.7246 21.7929L41.098 24.0405C41.5275 24.3223 41.8545 24.7352 42.0302 25.2179C42.206 25.7005 42.2211 26.2271 42.0733 26.719C41.9255 27.211 41.6228 27.642 41.2102 27.9479C40.7975 28.2538 40.2971 28.4183 39.7835 28.4167H36.6668",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.334 17.4166V15.5833",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 30.25V28.4167",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33312 2.74997H4.21645C3.70232 2.74721 3.20108 2.91078 2.78754 3.21626C2.374 3.52175 2.07033 3.95277 1.92186 4.44501C1.77338 4.93724 1.78806 5.46429 1.96371 5.94749C2.13935 6.4307 2.46655 6.84415 2.89645 7.12614L6.26979 9.37381C6.69969 9.6558 7.02688 10.0692 7.20253 10.5525C7.37818 11.0357 7.39286 11.5627 7.24438 12.0549C7.09591 12.5472 6.79224 12.9782 6.3787 13.2837C5.96516 13.5892 5.46392 13.7527 4.94979 13.75H1.83312",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.75002V0.916687",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 15.5833V13.75",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.666 9.16665L20.166 4.58331L14.666 9.16665C13.8755 9.81932 13.2844 10.6811 12.9602 11.6536C12.6361 12.6261 12.5919 13.6702 12.8327 14.6666L16.4993 28.4166H23.8327L27.4993 14.6666C27.7401 13.6702 27.6959 12.6261 27.3718 11.6536C27.0476 10.6811 26.4565 9.81932 25.666 9.16665Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5438 21.0833L12.9818 21.8918C12.3848 22.2007 11.8841 22.6678 11.5346 23.242C11.185 23.8163 11.0001 24.4756 11 25.1478V30.371C11.0001 30.5368 11.0451 30.6995 11.1304 30.8417C11.2156 30.9839 11.3378 31.1004 11.484 31.1786C11.6302 31.2569 11.7948 31.294 11.9605 31.2861C12.1261 31.2782 12.2865 31.2255 12.4245 31.1336L16.5 28.4166",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7902 21.0833L27.3522 21.8918C27.9492 22.2007 28.4499 22.6678 28.7994 23.242C29.1489 23.8163 29.3339 24.4756 29.334 25.1478V30.371C29.3339 30.5368 29.2888 30.6995 29.2036 30.8417C29.1184 30.9839 28.9962 31.1004 28.85 31.1786C28.7038 31.2569 28.5391 31.294 28.3735 31.2861C28.2079 31.2782 28.0475 31.2255 27.9095 31.1336L23.834 28.4166",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.166 16.5C21.6848 16.5 22.916 15.2688 22.916 13.75C22.916 12.2312 21.6848 11 20.166 11C18.6472 11 17.416 12.2312 17.416 13.75C17.416 15.2688 18.6472 16.5 20.166 16.5Z",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9162 34.8333C10.1764 34.8333 8.24953 35.8435 8.24953 37.5833C8.24953 37.7245 8.2312 38.3625 8.24953 38.5H7.33286C6.72671 38.4844 6.12372 38.5922 5.56059 38.817C4.99745 39.0418 4.48594 39.3789 4.05718 39.8076C3.62843 40.2364 3.29139 40.7479 3.06659 41.311C2.84178 41.8742 2.73391 42.4772 2.74953 43.0833",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 34.8333C29.2398 34.8333 31.1667 35.8435 31.1667 37.5833C31.1667 37.7245 31.185 38.3625 31.1667 38.5H32.0833C32.6895 38.4844 33.2925 38.5922 33.8556 38.817C34.4188 39.0418 34.9303 39.3789 35.359 39.8076C35.7878 40.2364 36.1248 40.7479 36.3496 41.311C36.5744 41.8742 36.6823 42.4772 36.6667 43.0833",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainPathway);
export default __webpack_public_path__ + "static/media/train_pathway.c8a2d7f33be216eee36e5479510f2e71.svg";
export { ForwardRef as ReactComponent };